import styled from '@emotion/styled';
import * as React from 'react';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { getBicycleColor, getTextColor } from '@/utility/theme/bicycleColor';

interface BicycleNumberProps {
  bicycleNum: number;
  grayOut?: boolean;
  size?: string | string[];
}

const BicycleNumCircle = styled.span((props: BicycleNumberProps) =>
  mq({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: props.size || '24px',
    height: props.size || '24px',
    background: props.grayOut
      ? defaultTheme.background.darkGray
      : getBicycleColor(props.bicycleNum),
    border:
      props.bicycleNum === 1 && !props.grayOut
        ? `1px solid ${defaultTheme.border.color.darkGray}`
        : 'none',
    borderRadius: defaultTheme.border.radius.circle,
    fontSize: [
      defaultTheme.font.size.xs,
      defaultTheme.font.size.xs,
      defaultTheme.font.size.s,
      defaultTheme.font.size.s,
    ],
    fontFamily: defaultTheme.font.family.bicycleNumber,
    fontWeight: 'bold',
    lineHeight: 1,
    color: props.grayOut
      ? defaultTheme.color.white
      : getTextColor(props.bicycleNum),
  }),
);

const BicycleNumber: React.FC<BicycleNumberProps> = props => (
  <BicycleNumCircle {...props} />
);

export default BicycleNumber;
